import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { enabled: Boolean, interval: { type: Number, default: 15000 } }

  connect() {
    if (!this.enabledValue) return
    this.timer = window.setInterval(() => {
      if (!document.hidden && !this.element.querySelector("form[aria-busy='true']")) {
        Turbo.visit(window.location.href, { action: "replace" })
      }
    }, this.intervalValue)
  }

  disconnect() {
    window.clearInterval(this.timer)
  }
}
